import { PERMISSION_OBJ_ATTACHMENT, PERMISSION_READ } from '@/constants/permissions';

import { AttachmentHistory } from './table';

export const states = [
  {
    name: 'base-layout.attachment-history',
    url: '/attachment-history',
    component: AttachmentHistory,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_ATTACHMENT, PERMISSION_READ]],
    },
  },
];
